import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React from 'react';
import classNames from 'classnames';
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

export const UserConfirmationPage = () => {

    const [todo, setTodo] = React.useState('');
    const [username, setUsername] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [createdAt, setCreatedAt] = React.useState('');
    const [expired, setExpired] = React.useState('');
    const [status, setStatus] = React.useState('');

    const [submitted, setSubmitted]  = React.useState(false);
        
    const statusOption = [
        {label: 'Telah Konfirmasi', value: 1},
        {label: 'Belum Konfirmasi', value: 0}
    ];

    const location = useLocation();
    const history = useHistory();

    React.useEffect(function() {
        setTodo(location.state.todo);
        if(location.state.todo === 'Ubah') {
            setUsername(location.state.dataUserConfirmation.user.username);
            setEmail(location.state.dataUserConfirmation.email);
            setCreatedAt(dateFormat(new Date(location.state.dataUserConfirmation.createdAt)));
            setExpired(dateFormat(new Date(location.state.dataUserConfirmation.expired)));
            setStatus(location.state.dataUserConfirmation.status);
        }        
      }, [location]);

      function dateFormat(date) {
        return  [
                    date.getDate() < 10 ? '0'+date.getDate():date.getDate(), 
                    date.getMonth()+1 < 10 ? '0'+Math.round(date.getMonth()+1):date.getMonth()+1, 
                    date.getFullYear()
                ]
                .join('/')+' '+
                [
                    date.getHours() < 10 ? '0'+date.getHours():date.getHours(), 
                    date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()
                ]
                .join(':');

    }

    async function clickSubmit(event) {
        event.preventDefault();
        setSubmitted(false);
        history.push('/users-confirmation');
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>{todo} User Confirmation</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
                <div className='card p-fluid'>
                    
                    <form onSubmit={clickSubmit}>
                        <div className="field">
                            <label htmlFor="username">Username</label>
                            <InputText id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} className={classNames({ 'p-invalid': submitted && !username })} />
                            {submitted && !username && <small className="p-error">Enter your username</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="email">email</label>
                            <InputText id="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} className={classNames({ 'p-invalid': submitted && !email })} />
                            {submitted && !email && <small className="p-error">Enter your email</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="createdAt">Created At</label>
                            <InputText id="createdAt" type="text" value={createdAt} onChange={(e) => setEmail(e.target.value)} className={classNames({ 'p-invalid': submitted && !createdAt })} />
                            {submitted && !createdAt && <small className="p-error">Enter your created at</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="expired">Expired</label>
                            <InputText id="expired" type="text" value={expired} onChange={(e) => setExpired(e.target.value)} className={classNames({ 'p-invalid': submitted && !expired })} />
                            {submitted && !expired && <small className="p-error">Enter your expired</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="status">Status</label>
                            <Dropdown id="status" value={status} onChange={(e) => setStatus(e.target.value)} options={statusOption} optionLabel="label" optionValue="value" placeholder="Select One" className={classNames({ 'p-invalid': submitted && !status })}></Dropdown>
                            {submitted && !status && <small className="p-error">Enter your status</small>}
                        </div>
                        <Button label="Back" className="p-button-secondary mr-2 mb-2" />
                    </form>
                </div>  
            </div>
        </div>
    );
}
